import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { UserLabel } from '@/models/label.model';
import { useEvents, Event } from '@/services/events.composable';
import { Actions, Mutations, ShiftCMSState } from '@/store';
import { LabelsActions, LabelsState } from '@/stores/labels.store';
import { NEW_ID } from '@/util/constants';
import { computed, onMounted, PropType, ref } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'LabelForm',
  props: {
  data: {
    type: Object as PropType<UserLabel>,
  },
},
  setup(__props) {

const store = useStore<ShiftCMSState & { ls: LabelsState }>();
const events = useEvents();

const props = __props;

const valid = ref<boolean>(false);

const label = ref<UserLabel>({
  id: NEW_ID,
  value: '',
});

const action = computed<string>(() =>
  label.value.id === NEW_ID ? 'Add' : 'Save',
);

const saveCategory = async () => {
  let success: boolean = false;
  if (valid.value) {
    if (label.value.id === NEW_ID) {
      success = await store.dispatch(LabelsActions.AddLabel, label.value);
    } else {
      success = await store.dispatch(LabelsActions.UpdateLabel, label.value);
    }
  }
  if (success) {
    events.emit(Event.Saved, true);
    store.dispatch(Actions.ShowNotification, {
      message: 'Saved label',
      type: 'success',
    });
    store.commit(Mutations.HideDrawer);
    store.dispatch(LabelsActions.GetLabels);
  } else {
    store.dispatch(Actions.ShowNotification, {
      message: 'Failed to save label',
      type: 'error',
    });
  }
};

onMounted(() => {
  if (props.data) {
    Object.assign(label.value, props.data);
  }
});

const removeLabel = async () => {
  if (
    label.value &&
    label.value.id !== NEW_ID &&
    confirm('Are you absolutely sure you want to delete this "Label"?')
  ) {
    store.dispatch(LabelsActions.DeleteLabel, label.value.id);

    store.commit(Mutations.HideDrawer);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    modelValue: valid.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((valid).value = $event)),
    onSubmit: _withModifiers(saveCategory, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t(action.value)) + " a label", 1),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "mx-auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: label.value.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((label.value.value) = $event)),
                    label: "Value",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { col: "2" }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "button",
                    color: "warning",
                    onClick: removeLabel,
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createTextVNode("Delete")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "reset",
                    block: ""
                  }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("Reset")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    class: "mt-2",
                    type: "submit",
                    color: "success",
                    block: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(action.value), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { col: "2" })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})